"use strict";

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZoraProfiles = void 0;

var tslib_1 = require("tslib");

var axios_1 = tslib_1.__importDefault(require("axios"));

var ZORA_API_BASE_URL = 'https://zora.co';
var MAX_USERS_PER_REQUEST = 100;
/**
 * Returns a list of Zora user profiles given a list of up to 100 addresses
 * @param addresses
 */

function getZoraProfiles(_x) {
  return _getZoraProfiles.apply(this, arguments);
}

function _getZoraProfiles() {
  _getZoraProfiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(addresses) {
    var res, msg;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(addresses.length === 0)) {
              _context.next = 2;
              break;
            }

            throw new Error('Empty addresses array');

          case 2:
            if (!(addresses.length > MAX_USERS_PER_REQUEST)) {
              _context.next = 4;
              break;
            }

            throw new Error("Addresses array exceeds max length of ".concat(MAX_USERS_PER_REQUEST));

          case 4:
            _context.prev = 4;
            _context.next = 7;
            return axios_1.default.post("".concat(ZORA_API_BASE_URL, "/api/users"), {
              addresses: addresses
            });

          case 7:
            res = _context.sent;

            if (!(!res.data || !Array.isArray(res.data) || res.data.length === 0)) {
              _context.next = 10;
              break;
            }

            throw new Error();

          case 10:
            return _context.abrupt("return", res.data);

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](4);

            if (_context.t0.response && _context.t0.response.data && typeof _context.t0.response.data === 'string') {
              msg = _context.t0.response.data;
            } else if (_context.t0.message) {
              msg = _context.t0.message;
            } else {
              msg = 'Error retrieving users';
            }

            throw new Error(msg);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 13]]);
  }));
  return _getZoraProfiles.apply(this, arguments);
}

exports.getZoraProfiles = getZoraProfiles;